import { c as _c } from "react/compiler-runtime";
import { getTranslations } from "next-intl/server";
import React from "react";
import { fetchFinishRegistrationEmail } from "../api";
import { FinishRegistrationForm } from "../components/finish-registration-form";
type FinishRegistrationViewPageProps = {
  emailPromise: ReturnType<typeof fetchFinishRegistrationEmail>;
  inviteToken: string;
  success?: boolean;
};
export const FinishRegistrationViewPage: React.FC<FinishRegistrationViewPageProps> = async t0 => {
  const $ = _c(7);
  const {
    emailPromise,
    inviteToken,
    success
  } = t0;
  let t1;
  let t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    const title = await getTranslations("Title.FinishRegistration");
    t1 = "auth__stack-center auth__finish-registration-view";
    t2 = <h1 className="auth__title-primary auth__finish-registration-title">{title("title")}</h1>;
    t3 = <p className="auth__finish-registration-description">{title("description")}</p>;
    $[0] = t1;
    $[1] = t2;
    $[2] = t3;
  } else {
    t1 = $[0];
    t2 = $[1];
    t3 = $[2];
  }
  let t4;
  if ($[3] !== emailPromise || $[4] !== inviteToken || $[5] !== success) {
    t4 = <section className={t1}>{t2}{t3}<FinishRegistrationForm emailPromise={emailPromise} inviteToken={inviteToken} success={success} /></section>;
    $[3] = emailPromise;
    $[4] = inviteToken;
    $[5] = success;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
};